import { render } from "./HeroSection.vue?vue&type=template&id=4c160665&scoped=true"
const script = {}

import "./HeroSection.vue?vue&type=style&index=0&id=4c160665&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c160665"]])

export default __exports__